<!-- フッター -->
<template>
  <CMS
    contents_type="block_contents"
    location_code="CRPG_TOP_99_001-footer"
  />
</template>

<script>
import CMS from "@/components/CMS.vue";

export default {
  name: "CrpgOrganismsCommonFooter",
  components: {
    CMS,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/organisms/common/footer.scss";
</style>
